export default {
  rateExceeded: 'Limite de demandes dépassée. L\'application reprendra dans {ttl} secondes.',
};
